import { render } from "./SearchView.vue?vue&type=template&id=fb9ff54c&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=fb9ff54c&scoped=true&lang=css"
import "./SearchView.vue?vue&type=style&index=1&id=fb9ff54c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9ff54c"]])

export default __exports__